<template>
  <div id="tags-view-container" :class="['tags-view-container',{'active':isCollapse},{'close-active':!bookmark}]">
    <scroll-pane ref="scrollPane" v-show="flag" class="tags-view-wrapper">
      <router-link v-for="tag in visitedViews" ref="tag" :key="tag.path" :class="isActive(tag)?'active':''"
        :to="{ path: tag.path, query: tag.query, fullPath: tag.fullPath }" tag="span" class="tags-view-item"
        @click.middle.native="!isAffix(tag)?closeSelectedTag(tag):''"
        @contextmenu.prevent.native="openMenu(tag,$event)">
        {{ tag.title }}
        <span v-if="!isAffix(tag)" class="el-icon-close" @click.prevent.stop="closeSelectedTag(tag)" />
      </router-link>
    </scroll-pane>
    <ul v-show="visible" :style="{left:left+'px',top:top+'px'}" class="contextmenu">
      <li @click="refreshSelectedTag(selectedTag)">刷新当前</li>
      <li v-if="!isAffix(selectedTag)" @click="closeSelectedTag(selectedTag)">关闭当前</li>
      <li @click="closeOthersTags(selectedTag)">关闭其他</li>
      <li @click="closeAllTags(selectedTag)">关闭所有</li>
    </ul>
    <span class="el-icon-menu rightbtn" @click="openMenu2($event)"></span>
  </div>
</template>

<script>
  import ScrollPane from './ScrollPane'
  import path from 'path'

  export default {
    components: { ScrollPane },
    props:['menuArr'],
    data() {
      return {
        isCollapse: false,
        flag: true,
        visible: false,
        top: 0,
        left: 0,
        selectedTag: {},
        affixTags: [],
        //存储的路由
        visitedViews:[ ],
        //跳转路由
        nowTo:{}
      }
    },
    computed: {
      routes() {
        return []
      },
       setIsCollapse() {//当前建筑
				return this.$store.cacheStore.state.setIsCollapse;
			},
    	bookmark() {
				return this.$store.menuStore.state.bookmark
			},
    },
    watch: {
      '$route' (to) {
           this.nowTo = to
           if(this.menuArr.length != 0){
             this.visitedViews_fn()
           }
      },
       setIsCollapse(val){
				this.isCollapse =  val
			},
      visible(value) {
        if (value) {
          document.body.addEventListener('click', this.closeMenu)
        } else {
          document.body.removeEventListener('click', this.closeMenu)
        }
      },
      menuArr(val){
        if(val.length != 0){
           this.visitedViews_fn()
        }
      },
      bookmark(){}
    },
    mounted() {
      console.log("第一个菜单",this.menuArr[0]);
      this.visitedViews.push({
                      path:this.menuArr[0].webpage,
                      query:{},
                      fullPath:this.menuArr[0].webpage,
                      title:this.menuArr[0].rightname
                    })
       this.visitedViews_fn()
      this.initTags()
      this.addTags()
    },
    methods: {
      //延迟一下
      visitedViews_fn(){
         var arr = this.visitedViews.filter(item => item.fullPath == this.nowTo.fullPath)
         var nameArr = this.menuArr.filter(item => item.webpage == this.nowTo.path)
             this.$emit('nowMenu_fn',nameArr)
           if(arr.length == 0){
             if(nameArr.length != 0) {
                 if(this.nowTo.path != '/watcher'){
                     this.visitedViews.push({
                      path:this.nowTo.path,
                      query:this.nowTo.query,
                      fullPath:this.nowTo.fullPath,
                      title:nameArr[0].rightname
                    })
                 }
                  
                }
           } 
      },
      openMenu2($event) { 
        this.visitedViews.map(v => {
          if (this.isActive(v)) {
           
            this.openMenu(v, $event);
            setTimeout(() => {
              this.visible=true;
            }, 200);
          }
        })
      },

      isActive(route) {
        return route.path === this.$route.path
      },
      isAffix(tag) {
        return tag.meta && tag.meta.affix
      },
      filterAffixTags(routes, basePath = '/') {
        let tags = []
        routes.forEach(route => {
          if (route.meta && route.meta.affix) {
            const tagPath = path.resolve(basePath, route.path)
            tags.push({
              fullPath: tagPath,
              path: tagPath,
              name: route.name,
              meta: { ...route.meta }
            })
          }
          if (route.children) {
            const tempTags = this.filterAffixTags(route.children, route.path)
            if (tempTags.length >= 1) {
              tags = [...tags, ...tempTags]
            }
          }
        })
        return tags
      },
      initTags() {
        const affixTags = this.affixTags = this.filterAffixTags(this.routes)
        for (const tag of affixTags) {
          // Must have tag name
          if (tag.name) {
            // this.$store.dispatch('tagsView/addVisitedView', tag)
          }
        }
      },
      addTags() {
        const { name } = this.$route
        if (name) {
          // this.$store.dispatch('tagsView/addView', this.$route)
        }
        return false
      },
      moveToCurrentTag() {
        const tags = this.$refs.tag
        // this.$nextTick(() => {
        //   for (const tag of tags) {
        //     if (tag.to.path === this.$route.path) {
        //       this.$refs.scrollPane.moveToTarget(tag)
        //       if (tag.to.fullPath !== this.$route.fullPath) {
        //         // this.$store.dispatch('tagsView/updateVisitedView', this.$route)
        //       }
        //       break
        //     }
        //   }
        // })
      },
      //刷新当前
      refreshSelectedTag(view) {
         this.$nextTick(() => {
           this.$router.push('/watcher')
           setTimeout(() => {
            this.$router.push(view.fullPath)
            }, 100);
         })
        // this.$store.dispatch('tagsView/delCachedView', view).then(() => {
        //   const { fullPath } = view
        //   this.$nextTick(() => {
        //     this.$router.replace({
        //       path: '/redirect' + fullPath
        //     })
        //     setTimeout(() => {
        //       this.$router.replace({
        //         path: fullPath
        //       })
        //     }, 100);
        //   })
        // })
      },
        //关闭当前
      closeSelectedTag(view) {
         if (this.isActive(view)) {
            this.toLastView(view)
          }else {
             var index = this.visitedViews.findIndex(item => item.path == view.path)
              this.visitedViews.splice(index,1)
          }
      },
      //关闭其他
      closeOthersTags(view) {
         if (this.isActive(view)) {
            this.visitedViews = [view]
          }else {
             this.visitedViews = []
             this.$router.push(view.fullPath)
          }
      },
      //关闭所有
      closeAllTags(view) {
          this.visitedViews = []
      },
      //关闭页面
      toLastView(view) {
        var index = this.visitedViews.findIndex(item => item.path == view.path)
        var newIndex = 0
        if(index == this.visitedViews.length -1){
          newIndex = index -1
        }else {
         newIndex = index + 1
        }
        if(newIndex != -1){
          const latestView = this.visitedViews[newIndex]
          this.$router.push(latestView.fullPath)
        }
        this.visitedViews.splice(index,1)
       
      },
      openMenu(tag, e) {
        const menuMinWidth = 105
        const offsetLeft = this.$el.getBoundingClientRect().left // container margin left
        const offsetWidth = this.$el.offsetWidth // container width
        const maxLeft = offsetWidth - menuMinWidth // left boundary
        const left = e.clientX - offsetLeft + 15 // 15: margin right

        if (left > maxLeft) {
          this.left = maxLeft
        } else {
          this.left = left
        }

        this.top = e.clientY - 50
        this.visible = true
        this.selectedTag = tag
      },
      closeMenu() {
        this.visible = false
      }
    }
  }
</script>

<style lang="scss" scoped>
  .rightbtn {
    position: absolute;
    right: 10px;
    top: 15px;
    cursor: pointer;
  }

  .rightbtn:hover {
    color: #007acc;
  }

  .tags-view-container {
    position: absolute;
    top: 0;
    right: 0;
    height: 40px;
   width: calc(100% - 2rem);
   transition: 0.35s;
    background: #fff;
    border-bottom: 1px solid #d8dce5;
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, .12), 0 0 3px 0 rgba(0, 0, 0, .04);
    //  overflow: hidden;
    &.active {
      width: calc(100% - 0.8rem);
    }
    &.close-active {
      height: 0px;
      overflow: hidden;
          display: none;
     
    }

    .tags-view-wrapper {
      width: 97%; 
     height: 40px;

      .tags-view-item {
        display: inline-block;
        position: relative;
        cursor: pointer;
        height: 26px;
        line-height: 26px;
        border: 1px solid #d8dce5;
        color: #495060;
        background: #fff;
        padding: 0 8px;
        font-size: 13px;
        margin-left: 5px;
        margin-top: 6px;
        border-radius: 2px;
        // display: flex;
        // align-items: center;

        &:first-of-type {
          margin-left: 15px;
        }

        &:last-of-type {
          margin-right: 15px;
        }

        &.active {
          // background-color: #42b983;
          // color: #fff;
          // border-color: #42b983;

          &::before {
            content: '';
            background: #fff;
            display: inline-block;
            width: 6px;
            height: 6px;
            border-radius: 50%;
            position: relative;
            margin-right: 2px;
            top: -2px;
          }
        }
      }
    }

    .contextmenu {
      margin: 0;
      background: #fff;
      z-index: 9999;
      position: absolute;
      list-style-type: none;
      padding: 5px 0;
      border-radius: 4px;
      font-size: 12px;
      font-weight: 400;
      color: #333;
      box-shadow: 2px 2px 3px 0 rgba(0, 0, 0, .3);

      li {
        margin: 0;
        padding: 3px 13px;
        font-size: 12px;
        cursor: pointer;

        &:hover {
          background: #eee;
        }
      }
    }
  }
</style>

<style lang="scss">
  //reset element css of el-icon-close
  .tags-view-wrapper {
    .tags-view-item {
      .el-icon-close {
        width: 16px;
        height: 16px;
        vertical-align: 2px;
        position: relative;
    top: 4px;
        border-radius: 50%;
        text-align: center;
        transition: all .3s cubic-bezier(.645, .045, .355, 1);
        transform-origin: 100% 50%;

        &:before {
          transform: scale(.6);
          display: inline-block;
        }

        &:hover {
          background-color: #b4bccc;
          color: #fff;
        }
      }
    }
  }
</style>